import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskForgeAppsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskForgeAppsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { forgeProjectSettingsModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { projectContextResourceWithCache } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import ForgeProjectSettingsPage, { LazyForgeProjectSettingsPage } from './ui/forge/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskForgeAppsRouteEntry: Route = createEntry(
	projectSettingsServicedeskForgeAppsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ForgeProjectSettingsPage,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResourceWithCache,
			forgeProjectSettingsModuleResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyForgeProjectSettingsPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
